import { ActionReducer } from "@ngrx/store";
import {
  Data,
  DataAction,
  DATA_REQUEST,
  DATA_REQUEST_FAILURE,
  DATA_REQUEST_SUCCESS,
  DATA_REQUEST_PROCESSING,
} from "../actions/data.action";
import {
  startOfDay,
  isSameDay,
  setHours,
  addMinutes,
  setMinutes,
  getMinutes,
  getHours,
  getMonth,
  subHours,
  isToday,
} from "date-fns";
import update from "immutability-helper";

const defaultDataState: Data = new Data();
let workDay: any = {};
// data reducer config
export const data: ActionReducer<any> = (
  state: Data = defaultDataState,
  action: DataAction
) => {
  switch (action.type) {
    case DATA_REQUEST:
      if (action.payload) {
        state = update(state, { $merge: action.payload });
      }
      return {
        ...state,
      };
    case DATA_REQUEST_PROCESSING:
      return {
        ...state,
      };
    case DATA_REQUEST_SUCCESS:
      if (action.payload['week']) {
        const uniqueLocations = Array.from(new Set([...(action.payload['week'].map(item =>  item.location))]));
        const arrayToStore = uniqueLocations.filter((el) => el !== null);
        localStorage.setItem('locations', JSON.stringify(arrayToStore));
      }
      const getTimeZone = () => {
        let offset: any = new Date();
        offset = offset.getTimezoneOffset();
        const o = Math.abs(offset);
        return {
          sing: offset < 0 ? "+" : "-",
          minutes: +("00" + (o % 60)).slice(-2),
          hours:
            +("00" + Math.floor(o / 60)).slice(-2) +
            (getMonth(new Date()) >= 4 && getMonth(new Date()) < 10 ? -1 : 0),
        };
      };
      if (action.payload["dateBusy"]) {
        // delete all dates if they aren't in work week
        action.payload["date"] = action.payload["date"].filter((event) => {
          workDay = state["week"].find(
            (dayOfWeek) =>
              dayOfWeek.day ===
              [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
              ][event.start.getDay()]
          );
          if (workDay && workDay.startTime) {
            const dayStart = setMinutes(
              setHours(
                startOfDay(event.start),
                +workDay.startTime.split(":")[0] - getTimeZone().hours
              ),
              +workDay.startTime.split(":")[1]
            );
            const dayEnd = setMinutes(
              setHours(
                startOfDay(event.start),
                +workDay.endTime.split(":")[0] - getTimeZone().hours
              ),
              +workDay.endTime.split(":")[1]
            );
            if (event.title === "!Morning") {
              if (getHours(dayStart) < 12) {
                return event;
              }
            } else if (event.title === "!Afternoon") {
              if (getHours(dayStart) < 16 && getHours(dayEnd) < 16) {
                return event;
              }
            } else {
              if (getHours(dayStart) < 23 && getHours(dayEnd) < 23) {
                return event;
              }
            }
          }
        });
      }
      if (
        Object.keys(action.payload).join("") === "day" &&
        !action.payload["day"]
      ) {
        state = update(state, { $merge: { times: [] } });
      } else if (action.payload["day"]) {
        // create times for selection
        if (action.payload["day"][0]) {
          action.payload["day"] = action.payload["day"][0];
        }
        if (action.payload["day"].startTime) {
          const date: any = {
            start: setMinutes(
              setHours(
                startOfDay(new Date()),
                +action.payload["day"].startTime.split(":")[0]
              ),
              +action.payload["day"].startTime.split(":")[1]
            ),
            finish: setMinutes(
              setHours(
                startOfDay(new Date()),
                +action.payload["day"].endTime.split(":")[0]
              ),
              +action.payload["day"].endTime.split(":")[1]
            ),
            time: +localStorage.getItem("treatmentTime"),
          };

          let startWorking = date.start;
          date.timeCreation = function (index: number) {
            date.parts.push({
              id: index,
              value:
                `${getHours(startWorking)}:` +
                `${
                  getMinutes(startWorking) < 10
                    ? "0" + getMinutes(startWorking)
                    : getMinutes(startWorking)
                }`,
              status: false,
            });
            startWorking = addMinutes(startWorking, date.time);
          };
          date.minutes =
            (date.finish.valueOf() - date.start.valueOf()) / 1000 / 60;
          date.parts = [];
          for (let i = 0; i < Math.floor(date.minutes / date.time); i++) {
            date.timeCreation(i);
          }

          const dateOfWork = state["dateBusy"].filter(
            (dateBusy: any) =>
              startOfDay(dateBusy.start).getTime() ===
              startOfDay(JSON.parse(localStorage.getItem("day"))).getTime()
          );
          if (dateOfWork.length) {
            date.parts = date.parts.map((timePart: any) => {
              dateOfWork.forEach((datePart) => {
                if (
                  `${getHours(addMinutes(datePart.dayStart, date.time))}:${
                    getMinutes(addMinutes(datePart.dayStart, date.time)) < 10
                      ? "0" + getMinutes(addMinutes(datePart.dayStart, date.time))
                      : getMinutes(addMinutes(datePart.dayStart, date.time))
                  }` === timePart.value ||
                  (`${getHours(addMinutes(datePart.dayStart, date.time))}:${
                      getMinutes(addMinutes(datePart.dayStart, date.time)) < 10
                        ? "0" + getMinutes(addMinutes(datePart.dayStart, date.time))
                        : getMinutes(addMinutes(datePart.dayStart, date.time))
                    }` > timePart.value &&
                    `${getHours(addMinutes(datePart.dayEnd, date.time))}:${
                      getMinutes(addMinutes(datePart.dayEnd, date.time)) < 10
                        ? "0" + getMinutes(addMinutes(datePart.dayEnd, date.time))
                        : getMinutes(addMinutes(datePart.dayEnd, date.time))
                    }` < timePart.value)
                ) {
                  timePart.disable = true;
                }
              });
              return timePart;
            });
          }

          if (state["practitionerEvents"]) {
            const dayForTiming = startOfDay(
              JSON.parse(localStorage.getItem("day"))
            );
            date.parts = date.parts.map((timePart: any) => {
              state["practitionerEvents"].forEach((event: any) => {
                if (
                  startOfDay(event.start.dateTime).getTime() ===
                  dayForTiming.getTime()
                ) {
                  const dateWorkTimeObject = {
                    start: setMinutes(
                      setHours(dayForTiming, +timePart.value.split(":")[0]),
                      +timePart.value.split(":")[1]
                    ),
                    end: addMinutes(
                      setMinutes(
                        setHours(dayForTiming, +timePart.value.split(":")[0]),
                        +timePart.value.split(":")[1]
                      ),
                      date.time
                    ),
                  };
                  if (
                    dateWorkTimeObject.start.getTime() <=
                    new Date(event.start.dateTime).getTime() &&
                    dateWorkTimeObject.end.getTime() >
                    new Date(event.start.dateTime).getTime() &&
                    dateWorkTimeObject.end.getTime() <
                    new Date(event.end.dateTime).getTime()
                  ) {
                    timePart.disable = true;
                  }
                  if (
                    dateWorkTimeObject.start.getTime() >
                    new Date(event.start.dateTime).getTime() &&
                    ((dateWorkTimeObject.start.getTime() <
                      new Date(event.end.dateTime).getTime() &&
                      dateWorkTimeObject.end.getTime() >=
                      new Date(event.end.dateTime).getTime()) ||
                      dateWorkTimeObject.end.getTime() <=
                      new Date(event.end.dateTime).getTime())
                  ) {
                    timePart.disable = true;
                  }
                }
              });
              return timePart;
            });
          }
          const objOfTimeCompare = {
            first:
              date.parts[date.parts.length - 1].value.split(":")[0] * 60 +
              +date.parts[date.parts.length - 1].value.split(":")[1],
            second: workDay.endTime
              ? workDay.endTime.split(":")[0] * 60 +
              +workDay.endTime.split(":")[1]
              : 0,
          };
          if (objOfTimeCompare.first >= objOfTimeCompare.second) {
            date.parts = date.parts.slice(0, date.parts.length - 1);
          }

          if (isToday(new Date(JSON.parse(localStorage.getItem("day"))))) {
            date.parts = date.parts.filter((time) => {
              const objDataToCompare = {
                first: time.value.split(":")[0] * 60 + +time.value.split(":")[1],
                second:
                  getHours(subHours(new Date(), getTimeZone().hours)) * 60 +
                  getMinutes(subHours(new Date(), getTimeZone().hours)),
              };
              return objDataToCompare.first >= objDataToCompare.second;
            });
          }

          state["practitionerEvents"].forEach((dateBusyElement) => {
            if (
              isSameDay(
                startOfDay(JSON.parse(localStorage.getItem("day"))),
                new Date(dateBusyElement.start)
              )
            ) {
              date.parts = date.parts.filter((timeElement) => {
                const minutesTime =
                  +timeElement.value.slice(0, 2) * 60 +
                  +timeElement.value.slice(3);
                const minutesDateBusyStart =
                  getHours(subHours(dateBusyElement.start, getTimeZone().hours)) *
                  60 +
                  getMinutes(dateBusyElement.start);
                const minutesDateBusyEnd =
                  getHours(subHours(dateBusyElement.end, getTimeZone().hours)) *
                  60 +
                  getMinutes(dateBusyElement.end);
                if (
                  (minutesTime >= minutesDateBusyStart &&
                    minutesTime <= minutesDateBusyEnd) ||
                  (minutesTime <= minutesDateBusyStart &&
                    minutesTime + +localStorage.getItem("treatmentTime") >=
                    minutesDateBusyStart &&
                    (minutesTime + +localStorage.getItem("treatmentTime") <=
                      minutesDateBusyEnd ||
                      minutesTime + +localStorage.getItem("treatmentTime") >=
                      minutesDateBusyEnd))
                ) {
                  return false;
                }
                return true;
              });
            }
          });
          state = update(state, {$merge: {timeData: date}});
        }
      } else {
        state = update(state, { $merge: action.payload });
      }
      return {
        ...state,
      };
    case DATA_REQUEST_FAILURE:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/reducers/data.reducer.ts